import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryResultsModel } from '../../_base/crud';
// State
import { ReasonsState } from '../_reducers/reason.reducers';
import { Reason } from '../_models/reason.model';

export const selectReasonsState = createFeatureSelector<ReasonsState>('reasons');

export const selectReasonById = (reasonId: number) =>
  createSelector(selectReasonsState, (reasonsState) => reasonsState.entities[reasonId]);

export const selectReasonsPageLoading = createSelector(selectReasonsState, (reasonsState) => {
  return reasonsState.listLoading;
});

export const selectReasonsActionLoading = createSelector(
  selectReasonsState,
  (reasonsState) => reasonsState.actionsloading,
);

export const selectLastCreatedReasonId = createSelector(
  selectReasonsState,
  (reasonsState) => reasonsState.lastCreatedReasonId,
);

export const selectLastCreatedReason = createSelector(
  selectReasonsState,
  (reasonsState) => reasonsState.lastCreatedReason,
);

export const selectReasonsPageLastQuery = createSelector(
  selectReasonsState,
  (reasonsState) => reasonsState.lastQuery,
);
export const selectReasonError = createSelector(
  selectReasonsState,
  (reasonsState) => reasonsState.error,
);
export const selectReasonLatestSuccessfullAction = createSelector(
  selectReasonsState,
  (reasonsState) => reasonsState.latestSuccessfullAction,
);
export const selectReasonsInStore = createSelector(selectReasonsState, (reasonsState) => {
  const items = (reasonsState.ids as number[])
    .map((id) => reasonsState.entities[id])
    .filter((item): item is Reason => item !== undefined);
  return new QueryResultsModel(items, reasonsState.totalCount);
});

export const selectReasonsShowInitWaitingMessage = createSelector(
  selectReasonsState,
  (reasonsState) => reasonsState.showInitWaitingMessage,
);

export const selectHasReasonsInStore = createSelector(selectReasonsState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }

  return true;
});
